module.exports = __webpack_public_path__ + "img/46_12.6f702deb.png";